import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { POOL_ADDRESSES } from '../constants';
export var GetUserEMode = createPlugin({
    protocol: 'AaveV3',
    type: 'GETTER',
    method: 'getUserEMode',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    user: new FctAddress({}),
                },
            },
            output: {
                eMode: new FctValue({ innerIndex: 0 }),
            },
        });
    },
});
